import React from "react";
import {
    Box,
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import type {Supplier360} from "../../supplier360DemoData";
import {formatCurrency, formatDate, transactionStatusColor} from "../../supplier360Utils";

type Props = { supplier: Supplier360 };

export const TransactionsTab: React.FC<Props> = ({supplier}) => {
    const total = supplier.transactions.reduce((sum, t) => sum + t.amount, 0);

    return <Box>
        <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={1.5}>
            <Typography variant="body2" color="text.secondary">
                Showing {supplier.transactions.length} most recent of {supplier.transactionCount.toLocaleString()} transactions
            </Typography>
            <Typography variant="body2">
                Recent total: <strong>{formatCurrency(total, supplier.currency)}</strong>
            </Typography>
        </Box>
        <TableContainer component={Paper} variant="outlined" sx={{borderRadius: '10px'}}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>PO Number</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="center">Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {supplier.transactions.map(t => (
                        <TableRow key={t.id} hover>
                            <TableCell>{formatDate(t.date)}</TableCell>
                            <TableCell>{t.description}</TableCell>
                            <TableCell>{t.category}</TableCell>
                            <TableCell>
                                <Typography variant="body2" color="text.secondary">{t.poNumber}</Typography>
                            </TableCell>
                            <TableCell align="right">{formatCurrency(t.amount, supplier.currency)}</TableCell>
                            <TableCell align="center">
                                <Chip
                                    size="small"
                                    color={transactionStatusColor(t.status)}
                                    label={t.status.charAt(0).toUpperCase() + t.status.slice(1)}
                                    variant={t.status === 'paid' ? 'outlined' : 'filled'}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>;
};
